import serieALogo from '../assets/images/SerieALogo.png';
import championsLeagueLogo from '../assets/images/UEFA_Champions_League_logo_2.svg.png';
import europaLeagueLogo from '../assets/images/Logo_UEFA_Europa_League_-_2021.svg.png';
import conferenceLeagueLogo from '../assets/images/UECL_logo.png';
import superCupLogo from '../assets/images/UEFA_Super_Cup_logo.png';
import coppaItaliaLogo from '../assets/images/Coppa_Italia_logo.png';
import FALLBACK_TICKET_TEAMS_DEFAULT from './ticketOpponentTeams.default.json';

/** Aligné sur le modèle Ticket (backend/models/Ticket.js) — ordre fixe menus. */
export const TICKET_COMPETITION_ORDER = [
  'Serie A',
  'Champions League',
  'UEFA Europa League',
  'UEFA Europa Conference League',
  'UEFA Super Cup',
  'Coppa Italia',
  'Match amical',
];

function getCompetitionLogoMap() {
  return {
    'Serie A': serieALogo,
    'Champions League': championsLeagueLogo,
    'UEFA Europa League': europaLeagueLogo,
    'UEFA Europa Conference League': conferenceLeagueLogo,
    'UEFA Super Cup': superCupLogo,
    'Coppa Italia': coppaItaliaLogo,
    'Match amical': serieALogo,
  };
}

/**
 * Objet utilisé comme avant par AdminTicketForm : { [comp]: { name, logo, teams } }
 * @param {Record<string, string[]> | null | undefined} teamsByCompetition
 */
export function buildTicketCompetitionUiMap(teamsByCompetition) {
  const logos = getCompetitionLogoMap();
  const out = {};
  for (const key of TICKET_COMPETITION_ORDER) {
    const raw = teamsByCompetition?.[key];
    const teams =
      raw !== undefined && Array.isArray(raw)
        ? [...raw]
        : [...(FALLBACK_TICKET_TEAMS_DEFAULT[key] || [])];
    out[key] = { name: key, logo: logos[key], teams };
  }
  return out;
}
